import React from 'react';
import { theme } from '../../lib/theme';

interface FormLabelProps {
    children: React.ReactNode;
    className?: string;
    isFilled?: boolean;
}

export function FormLabel({ children, className, isFilled = false }: FormLabelProps) {
    const labelClasses = className || theme.typography.sectionLabel;
    
    const renderWithRedAsterisk = (node: React.ReactNode): React.ReactNode => {
        if (typeof node === 'string') {
            if (node.includes('*')) {
                const parts = node.split('*');
                return (
                    <>
                        {parts[0]}
                        <span className={`${isFilled ? '' : 'text-red-500 font-black'} ml-0.5 transition-colors duration-300`}>*</span>
                        {parts.slice(1).join('*')}
                    </>
                );
            }
            return node;
        }
        
        if (Array.isArray(node)) {
            return node.map((child, i) => <React.Fragment key={i}>{renderWithRedAsterisk(child)}</React.Fragment>);
        }
        
        if (React.isValidElement(node) && node.props.children) {
            return React.cloneElement(node, {
                ...node.props,
                children: renderWithRedAsterisk(node.props.children)
            } as any);
        }
        
        return node;
    };

    return (
        <label className={labelClasses}>
            {renderWithRedAsterisk(children)}
        </label>
    );
}
